import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools, persist } from "zustand/middleware";
import localforage from "localforage";

export function createPersistedStore<TState, TAction>(
  defaultState: TState,
  actions: (set: any) => TAction,
  persistName: string,
  partialize: (state: any) => any
) {
  return create<TState & TAction>()(
    devtools(
      persist(
        immer((set) => ({
          ...defaultState,
          ...actions(set),
        })),
        {
          name: persistName,
          storage: {
            getItem: (key: string): Promise<any> => localforage.getItem(key),
            setItem: (key: string, value: any): Promise<void> =>
              localforage.setItem(key, value),
            removeItem: (key: string): Promise<void> =>
              localforage.removeItem(key),
          },
          partialize,
        }
      ),
      {
        name: persistName + "Store",
        enabled: true,
      }
    )
  );
}